<div class="main-modal-wrapper" *ngIf="modalMode == 'add'; else edit_db_lookUp">
    <div class="modal-header">
        <h4>Add DBSelect Lookup item</h4>
        <a class="close-icon" href="javascript:void()" (click)="ngbActiveModal.close(false)" ngbAutofocus><i class="flaticon2-cross"></i></a>
    </div>
    <div class="modal-content-body">
        <div class="row">
            <div class="col-md-10">
                <div class="row" *ngFor="let lookup of newLookUpFieldArray.controls; let i = index" [formGroup]="newLookUpFieldArray.controls[i]">
                    <div class="col-md-5">
                        <div class="form-group">
                            <mat-label>Key</mat-label>
                            <mat-form-field class="example-full-width" [floatLabel]="'never'">
                                <input type="text" formControlName="key" matInput placeholder="Key" />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="form-group">
                            <mat-label>Value</mat-label>
                            <mat-form-field class="example-full-width" [floatLabel]="'never'">
                                <input type="text" formControlName="value" matInput placeholder="Value" />
                            </mat-form-field>
                            <span class="text-danger" *ngIf="newLookUpFieldArray.controls[i].get('value').hasError('alreadyExistInList')">
                                entered value already exists!
                            </span>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group-action">
                            <a
                                class="delete-icon"
                                [ngClass]="newLookUpFieldArray.controls.length == 1 ? 'anchor-disable' : ''"
                                (click)="dbLookUpFiledHandler(1, i)"
                            >
                                <mat-icon>delete</mat-icon></a
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <button
                    type="button"
                    class="btn primary-ebtn"
                    [disabled]="!(newLookUpFieldArray.controls.length < 15) || !newLookUpFieldArray.valid"
                    (click)="dbLookUpFiledHandler(0)"
                >
                    ADD
                </button>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn primary-ebtn" [disabled]="!newLookUpFieldArray.valid" (click)="saveModalData()">Save</button>
        <button type="button" (click)="closeClick()" class="btn secondary-ebtn me-3">Cancel</button>
    </div>
</div>

<ng-template #edit_db_lookUp>
    <div class="main-modal-wrapper edit-modal">
        <div class="modal-header">
            <h4>Update DBSelect Lookup item</h4>
            <a class="close-icon" href="javascript:void()" (click)="ngbActiveModal.close(false)" ngbAutofocus><i class="flaticon2-cross"></i></a>
        </div>

        <div class="modal-content-body" *ngIf="editLookUpForm" [formGroup]="editLookUpForm">
            <div class="row">
                <div class="col-md-10">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="form-group">
                                <mat-label>Key</mat-label>
                                <mat-form-field class="example-full-width" [floatLabel]="'never'">
                                    <input type="text" formControlName="dbSelectName" matInput placeholder="Key" />
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="form-group">
                                <mat-label>Value</mat-label>
                                <mat-form-field class="example-full-width" [floatLabel]="'never'">
                                    <input type="text" matInput formControlName="dbSelectValueName" placeholder="Value" />
                                </mat-form-field>
                                <span class="text-danger" *ngIf="editLookUpForm.get('dbSelectValueName').hasError('duplicateName')"
                                    >Value is already exist!</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn primary-ebtn" [disabled]="!(editLookUpForm.valid && editLookUpForm.dirty)" (click)="saveModalData()">
                Update
            </button>
            <button type="button" (click)="closeClick()" class="btn secondary-ebtn me-3">Cancel</button>
        </div>
    </div>
</ng-template>
